import { get } from "../../../core/api/client";
import { API_ENDPOINTS } from "../../../core/api/endpoints";

const sanitizeLimit = (value) => {
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return 20;
  return Math.min(100, Math.max(1, Math.trunc(numeric)));
};

const sanitizeOffset = (value) => {
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return 0;
  return Math.max(0, Math.trunc(numeric));
};

export const getInvoicesByClient = async (
  clientId,
  params = {},
) => {
  const { limit = 20, offset = 0, status } = params;
  const safeLimit = sanitizeLimit(limit);
  const safeOffset = sanitizeOffset(offset);

  const queryParams = [
    `limit=${encodeURIComponent(safeLimit)}`,
    `offset=${encodeURIComponent(safeOffset)}`,
  ];

  if (status) {
    queryParams.push(`status=${encodeURIComponent(status)}`);
  }

  const endpoint = `${API_ENDPOINTS.INVOICES.LIST_BY_CLIENT(clientId)}?${queryParams.join("&")}`;
  return get(endpoint);
};
